import { spacing, color, font, media } from "@universityofmaryland/web-token-library";
import "./typography/font-face/index.js";
import "./typography/campaign.js";
import "./typography/elements.js";
import { medium } from "./typography/sans.js";
import "./typography/serif.js";
import "./typography/stats.js";
import "./node_modules/.pnpm/postcss@8.5.8/node_modules/postcss/lib/postcss.js";
import "./node_modules/.pnpm/postcss-js@4.1.0_postcss@8.5.8/node_modules/postcss-js/index.js";
import "./node_modules/.pnpm/postcss-nesting@13.0.2_postcss@8.5.8/node_modules/postcss-nesting/dist/index.js";
import "./_virtual/index.js";
import { fromTokens } from "./utilities/transform/variables.js";
import { input } from "./element/field/input.js";
import { textarea } from "./element/field/textarea.js";
import { select } from "./element/field/select.js";
import { label } from "./element/text/label.js";
const reset = {
  "*": {
    margin: "0",
    padding: "0",
    boxSizing: "border-box"
  },
  body: {
    overscrollBehavior: "none"
  },
  "h1, h2, h3, h4, h5, h6": {
    marginBottom: "0",
    fontSize: "16px",
    lineHeight: "1.4em",
    fontWeight: "normal"
  },
  hr: {
    margin: `${spacing.lg} 0`,
    backgroundColor: color.gray.light,
    border: "none",
    height: "1px"
  },
  li: {
    ...medium,
    color: color.gray.dark
  },
  date: {
    color: color.black
  },
  p: {
    ...medium,
    color: color.gray.dark,
    marginBottom: spacing.md,
    "&:last-child": {
      marginBottom: "0"
    }
  },
  button: {
    border: "none",
    background: "none"
  },
  video: {
    maxWidth: "100%"
  },
  address: {
    fontStyle: "normal"
  },
  label: {
    ...label
  },
  input: {
    ...input
  },
  textarea: {
    ...textarea
  },
  select: {
    ...select
  },
  ".umd-layout-space-vertical-landing": {
    marginBottom: spacing.max
  },
  // Opt-in coordinated fade-in. Consumers add `umd-fout-gate` to <html> at
  // parse time and swap it for `umd-fout-ready` once all `umd-*` tags have
  // upgraded (or a fallback timeout fires).
  //
  // Gate on <html>, NOT <body>. Chrome's LCP algorithm disqualifies
  // candidates inside an opacity:0 subtree — except when documentElement
  // is the opacity-0 ancestor (carve-out for A/B testing tools). A body
  // gate would inflate LCP by the gate duration; an html gate does not.
  "html.umd-fout-gate": {
    opacity: 0
  },
  "html.umd-fout-ready": {
    opacity: 1,
    transition: "opacity 200ms ease"
  }
};
const variables = {
  "--serif": font.family.serif,
  "--sanSerif": font.family.sans,
  ...fromTokens(color, "umd-color-"),
  ...fromTokens(spacing, "umd-space-"),
  ...fromTokens(font.size, "umd-font-size-")
};
const root = {
  ":root": {
    ...variables,
    ...media.conditionals,
    ...{
      "font-family": font.family.sans,
      "font-size": font.size.base,
      "line-height": "1.5em"
    }
  }
};
export {
  reset,
  root,
  variables
};
//# sourceMappingURL=root.js.map
